// extracted by mini-css-extract-plugin
module.exports = {"container":"e_U-","hasBadge":"e_V-","bottomLine":"e_W-","imageContainer":"e_X-","image":"e_Y-","header":"e_Z-","title":"e__-","score":"e_0-"};